
import { useState, useEffect } from 'react';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/90 backdrop-blur-sm shadow-sm'
    }`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center">
            <h1 className="text-2xl font-bold text-orange-600">SellApartmentsCash</h1>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/we-buy-apartment-buildings" className="text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              We Buy Apartment Buildings
            </a>
            <a href="https://sellapartmentscash.com/sell-my-apartment-building" className="text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Sell My Apartments Fast
            </a>
            <a href="https://sellapartmentscash.com/how-it-works/selling-inherited-apartments" className="text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Seller Financing Sell Inherited Property
            </a>
            <a 
              href="https://sellapartmentscash.com#get-offer"
              className="bg-orange-600 text-white px-6 py-2 rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap"
            >
              Get Cash Offer
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-orange-600 transition-colors"
            aria-label="Toggle menu"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-4">
            <a href="/we-buy-apartment-buildings" className="block text-gray-700 hover:text-orange-600 transition-colors">
              We Buy Apartment Buildings
            </a>
            <a href="https://sellapartmentscash.com/sell-my-apartment-building" className="block text-gray-700 hover:text-orange-600 transition-colors">
              Sell My Apartments Fast
            </a>
            <a href="https://sellapartmentscash.com/how-it-works/selling-inherited-apartments" className="block text-gray-700 hover:text-orange-600 transition-colors">
              Seller Financing Sell Inherited Property
            </a>
            <a 
              href="https://sellapartmentscash.com#get-offer"
              className="block bg-orange-600 text-white px-6 py-2 rounded-lg hover:bg-orange-700 transition-colors text-center whitespace-nowrap"
            >
              Get Cash Offer
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
